// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.DeleteOneTimePaymentGroupWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteOneTimePaymentGroupWebApiRequestDto } from '../..';

export const DeleteOneTimePaymentGroupWebApiHandler_deleteOneTimePaymentGroup_Path =
  '/api/web/v1/payment/deleteOneTimePaymentGroup';

/**
 * Delete one time payment group
 */
export const DeleteOneTimePaymentGroupWebApiHandler_deleteOneTimePaymentGroup = (
  postData: DeleteOneTimePaymentGroupWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteOneTimePaymentGroupWebApiRequestDto, void>(
    {
      endpoint: DeleteOneTimePaymentGroupWebApiHandler_deleteOneTimePaymentGroup_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
